import script from "./Simulate.vue?vue&type=script&setup=true&lang=js"
export * from "./Simulate.vue?vue&type=script&setup=true&lang=js"

import "./Simulate.vue?vue&type=style&index=0&id=1e1ed1b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1ed1b8"]])

export default __exports__